import SubmitApplications from 'components/global/SubmitApplications';

const LenderSubmitApplications = () => <SubmitApplications />;

export default LenderSubmitApplications;
